import React from "react";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import { Outlet } from "react-router-dom";
import useRemittanceModule from "./useRemittanceModule";

const Remittance = () => {
  const { drawerMenu } = useRemittanceModule();
  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Remittance;
